import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
} from "@mui/material";
import "../../assets/styles/layout-styles.scss";
import "../../assets/styles/common-styles.scss";
import SettingsIcon from "@mui/icons-material/Settings";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PasswordIcon from "@mui/icons-material/Password";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { AppState, useAppSelector } from "../../store";
import { useLogout } from "../../hooks/useLogout";
import { AlertDialog } from "../common/AlertDailog";
import SwitchRole from "./SwitchRole";
import ChangePasword from "./ChangePasword";
import { useUsers } from "../../hooks/useUsers";
import { setUserObj } from "../../store/slices/commonSlice";
import { useDispatch } from "react-redux";
import BreadcrumbsNav from "./BreadcrumbsNav";
import { useLocation } from "react-router-dom";

const DashboardPage: React.FunctionComponent<any> = () => {
  const location = useLocation();
  const userObj = useAppSelector(
    (state: AppState) => state.commonSlice.userObj
  );
  const dispatch = useDispatch();
  const { first_name, last_name, loggedInTime, loggedInDate, defaultRole } =
    userObj;
  const { logout } = useLogout();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [logoutPopup, setLogoutPopup] = useState<boolean>(false);
  const [openSwitchRole, setOpenSwitchRole] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [getUserDetails, setGetUserDetails] = useState(false);
  const { getLoggedInUserRoles, loggedInUserRolesData } = useUsers();

  const onClickSwitchRole = () => {
    setOpenSwitchRole(true);
    setAnchorEl(null);
  };

  const onClickChangePassword = () => {
    setOpenChangePassword(true);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const handleClickSetting = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseSetting = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (getUserDetails) {
      getLoggedInUserRoles();
    }
  }, [getUserDetails]);

  useEffect(() => {
    if (loggedInUserRolesData) {
      const selectedRole = loggedInUserRolesData?.roles?.find(
        (item: { code: any }) =>
          item.code == loggedInUserRolesData?.default_role
      );
      dispatch(
        setUserObj({
          ...userObj,
          defaultRole: selectedRole?.name,
        })
      );
    }
  }, [loggedInUserRolesData]);

  return (
    <>
      <Box
        className="topBar"
        justifyContent={
          location?.pathname?.length ? "space-between" : "flex-end"
        }
      >
        <BreadcrumbsNav />
        <Stack direction="row" spacing={2}>
          <Box className="textRight">
            <Typography variant="body2" color="primary">
              {loggedInTime}
            </Typography>
            <Typography variant="body2" color="primary">
              {loggedInDate}
            </Typography>
          </Box>
          <Box className="MW200">
            <Typography
              variant="subtitle2"
              color="primary"
              className="textTruncate"
            >
              <Tooltip
                title={
                  first_name?.length + last_name?.length > 25
                    ? `${first_name} ${last_name}`
                    : null
                }
                placement="bottom"
              >
                <strong className="dBlock textTruncate">{`${first_name} ${last_name}`}</strong>
              </Tooltip>
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              className="textTruncate"
            >
              {defaultRole}
            </Typography>
          </Box>
          <IconButton
            aria-label="Site Settings"
            color="primary"
            id="sitesetting"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClickSetting}
          >
            <SettingsIcon />
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseSetting}
            MenuListProps={{
              "aria-labelledby": "Site-setting",
            }}
          >
            <MenuItem
              onClick={onClickSwitchRole}
              aria-label="Click to open Switch Role modal"
            >
              <ListItemIcon>
                <ManageAccountsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Switch Role</ListItemText>
            </MenuItem>
            <MenuItem
              onClick={onClickChangePassword}
              aria-label="Click to open Change Password modal"
            >
              <ListItemIcon>
                <PasswordIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Change Password</ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem
              onClick={() => {
                setLogoutPopup(true);
                setAnchorEl(null);
              }}
              aria-label="Click to logout"
            >
              <ListItemIcon>
                <ExitToAppIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </Menu>
        </Stack>
        <AlertDialog
          open={logoutPopup}
          title="Logout"
          description="Are you sure, you want to logout?"
          handleClose={() => setLogoutPopup(false)}
          handleConfirm={() => logout()}
          confirmBtn="Yes"
          cancelBtn="No"
          maxWidth="xs"
        />
      </Box>
      {openSwitchRole && (
        <SwitchRole
          openSwitchRole={openSwitchRole}
          setOpenSwitchRole={setOpenSwitchRole}
          setGetUserDetails={setGetUserDetails}
        />
      )}

      {openChangePassword && (
        <ChangePasword
          openChangePassword={openChangePassword}
          setOpenChangePassword={setOpenChangePassword}
        />
      )}
    </>
  );
};

export default DashboardPage;
